<template>
  <Modal :title="title" :showModal="showModal" class="edit-authentication-form" @submit="submit">
    <template v-slot:body>
      <div class="row">
        <div class="position-relative form-group col-12">
          <label class="col-12 mb-0 p-0">Type*</label>
          <Select class="mt-2 mb-2" :options="types" :value="data.type" @changeValue="changeType($event)"></Select>
        </div>
        <div class="position-relative form-group col-12">
          <label class="col-12 mb-0 p-0">Name*</label>
          <input class="form-control mt-2" type="text" :value="data.name" @change.stop.prevent="changeName($event)" />
        </div>
      </div>
      <div v-if="token" class="row token">
        <div class="position-relative form-group col-12">
          <label class="col-12 p-0">Refresh Token</label>
          <div class="p-2 token select-all">{{ token }}</div>
          <small>
            Document requires access token:
            <a :href="docUrl" target="_blank">{{ docUrl }}</a>
          </small>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script>
import Event from '@/helper/event.js'
export default {
  mixins: [Event],
  data() {
    return {
      showModal: null,
      token: null,
      docUrl: null,
      types: []
    }
  },
  computed: {
    title() {
      return 'Generate new token'
    },
    action() {
      return 'edit'
    },
    storeId() {
      return this.config?.storeId
    },
    getUri() {
      return `refresh-token/get`
    },
    submitUri() {
      return `refresh-token/create`
    },
    data() {
      return this.store.getter('', {})
    }
  },
  created() {
    this.store.commit('', {})
  },
  methods: {
    setUpData(rawData) {
      if (rawData.status == 'success') {
        this.showModal = true
        this.types = Object.values(rawData.data.types || [])
      }
    },
    changeName(e) {
      this.store.commit('name', e.target.value)
    },
    changeType(e) {
      this.store.commit('type', e)
    },
    submit() {
      this.submitForm(this.data, {
        done: (response) => {
          if (response.status == 'success') {
            this.token = response.data.refresh_token
            this.docUrl = response.data.doc_url
          }
        }
      })
    }
  },
  props: {
    config: Object
  }
}
</script>
<style lang="scss">
.edit-authentication-form {
  .row.token {
    .token {
      border: 1px solid #ccc;
      border-radius: var(--border-radius, 0.25rem);
    }
  }
}
</style>
